import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import React from 'react'
import SalesRedirectionButton from 'src/editor/pages/sales/entities/sales-redirection-button'
import { SalesRedirectionButtonEntityInterface } from 'src/shared/entities/sales-redirection-button/sales-redirection-button-entity.schema'
import createCommonEntityElement, {
  AdditionalProps,
} from '../createCommonEntityElement'

export default function createEntityElementForSales(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  switch (entity.type) {
    case EntityTypeEnum.SalesRedirectionButton:
      return (
        <SalesRedirectionButton
          entity={entity as SalesRedirectionButtonEntityInterface}
          {...additionalProps}
        />
      )
    default:
      return createCommonEntityElement(entity, additionalProps)
  }
}
